module.exports = __webpack_public_path__ + "assets/images/statue-03.459c0c2c5fb1e479769bdd1cee3a175d.svg";